import React, { useState, useEffect } from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import { Button, makeStyles, CircularProgress } from "@material-ui/core";
import { Pagination } from "react-bootstrap";
import { Connector } from "react-mqtt-client";
import { getBotMonitoring, findLoginId } from "../modules/api";
import Moment from "moment";
import MUIDataTable from "mui-datatables";
import * as mqtt from "react-paho-mqtt";

class SysAdminVariable {
	static selectBotAdminId;
	static selectBotAdminNo;
}
export function BotMonitoring() {
  const [listLoading, setListLoading] = useState(false);
  const [botMonitoringList, setBotMonitoringList] = useState([]);
  const [botAdminList, setBotAdminList] = useState([]);
	const [client, setClient] = useState();
	const [value, setValue] = useState();


  const useStyles = makeStyles((theme) => ({
    container: {
      display: "flex",
      flexWrap: "wrap",
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 200,
    },
    centeredHeader: {
      "& span": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: 15,
        fontWeight: "bold",
      },
    },
  }));

  const classes = useStyles();

	
  const fetchData = async (value, loginId) => {
	  SysAdminVariable.selectBotAdminId = loginId;
	  SysAdminVariable.selectBotAdminNo = value;

	  console.log("selectBotAdminId :: " + SysAdminVariable.selectBotAdminId);
	  setValue({});
  };


	//mqtt를 send 한 후 5초 뒤 다 받았다 라는 전제 하에 true로 바꿈
	let isReceivedAllMsg;

	//5초 동안 mqtt를 한건이라도 받은 경우
	let isReceivedMsg;
	let list;
	let mqttList;
	let userNo;
	let userId;

	useEffect(() => {
		console.log("========start==============");
		setBotMonitoringList([]);

	  const role = localStorage.getItem("userRole");
	  let interval;
	  let interval2;

	  setListLoading(true);
	  isReceivedAllMsg = true;
		list = [];
	  //첫 시작은 지연 시간 1초
	  let delayTime = 1000;
	  let c;
	
	  c = mqtt.connect(
		  "mqtt.laidback.co.kr",
		  Number(8883),
		  "a" + new Date().getTime(),
		  _onConnectionLost,
		  _onMessageArrived
	  ); // mqtt.connect(host, port, clientId, _onConnectionLost, _onMessageArrived)

		if (role !== "SystemAdmin") {
			userNo = localStorage.getItem("userNo");
			if (role === "Bot") {
				userId = localStorage.getItem("botAdminId");
			}
			else {
				userId = localStorage.getItem("userId");
            }
			

		  c.connect({
			  useSSL: true,
			  onSuccess: () => {
				  console.log("su");
				  c.subscribe("aimily/res/" + userId + "/checkStatus", _options);
			  },
		  });
	  }
		else {
			userNo = SysAdminVariable.selectBotAdminNo;
			userId = SysAdminVariable.selectBotAdminId;

			//초기화
			SysAdminVariable.selectBotAdminNo = "";
			SysAdminVariable.selectBotAdminId = "";

			c.connect({
			  useSSL: true,
			  onSuccess: () => {
				  console.log("su");
				  c.subscribe("aimily/res/" + userId + "/checkStatus", _options);
			  },
		  });
			
		  async function systemAdminData() {
			  const botAdminList = await findLoginId();
			  console.log("botAdminList", botAdminList);
			  setBotAdminList(botAdminList.data);
		  }
		  systemAdminData();
	  }

	  setClient(c);

	 
	interval = setInterval(async () => {
		if (isReceivedAllMsg) {
			let list2 = [];

			const result = await getBotMonitoring(userNo);
			console.log("monitoringList", result);

			if (result.data !== undefined && result.data.length > 0) {
				setListLoading(true);
				list = [];
				result.data.map((data, index) => {
					var obj = new Object();
					obj.idx = index;
					obj.no = data.no;
					obj.botId = data.loginId;
					obj.botFailCnt = data.botExeCnt - data.successCnt;
					obj.botExeCnt = data.botExeCnt;
					obj.botExeRate = data.botExeCnt + "/" + data.allExeCnt;
					obj.botAllExeCnt = data.allExeCnt;
					obj.botSuccessCnt = data.successCnt;
					obj.lastDate = data.lastDate
						? Moment(data.lastDate).format("YYYY-MM-DD HH:mm:ss")
						: "-";
					obj.botStatus = 9;
					obj.botExeName = "-";
					obj.botExeType = 9;
					list.push(obj);
				});
				list2 = [...list];
				if (list.length > 0 && c !== undefined) {
					console.log("====_onSendMessage======");
					isReceivedAllMsg = false;
					isReceivedMsg = false;
					
					try {
						_onSendMessage(c);
						//다 받을 때까지 2초 대기()
						interval2 = setTimeout(function () {
							//한 건이라도 받은 이력이 존재할 경우
							if (isReceivedMsg) {
								setBotMonitoringList(mqttList);
							}
							else {
								setBotMonitoringList(list2);
                            }
							isReceivedAllMsg = true;
							//두번째 부터는 2초로 바꿈
							if (delayTime == 1000) delayTime = 2000;
						}, delayTime);

					} catch (e) {
						isReceivedAllMsg = true;
						console.log("send message error", e);
					}
				}
			}
			else {
				setListLoading(false);
				console.log("===result.data null===");
				setBotMonitoringList(list2);
				isReceivedAllMsg = true;
            }
		}
	}, 1000);

	return () => {
		clearInterval(interval);
		clearInterval(interval2);
		setBotMonitoringList([]);
		mqttList = [];
	};
	}, [value]);
  const _options = {};

  const _onConnectionLost = () => {};
	const _onMessageArrived = (message) => {
	if (message.topic.indexOf("checkStatus") > -1) {
		  console.log(message.payloadString);
      const json = JSON.parse(message.payloadString);
      const data = json.data;
      console.log(data.loginId, data);
		const newData = [...list].map((item) => {
        if (item.botId === data.loginId) {
          item.botStatus = data.status;
          item.botExeName = data.execNm;
          item.botExeType = data.execType;
        }
        return item;
      });
		  mqttList = newData;
		//false라면 true로 바꾸기
		if (!isReceivedMsg) isReceivedMsg = true;
    }
  };
  // 5초마다 publish
  const _onSendMessage = (c) => {
    // console.log(client);
    const jsonMessage = {
      trId: Math.random()
        .toString(36)
        .substr(2, 10),
    };

	  const role = localStorage.getItem("userRole");
	  if (role !== "SystemAdmin") {
		  const message = mqtt.parsePayload(
			  "aimily/req/" + userId + "/checkStatus",
			  JSON.stringify(jsonMessage)
		  );

		  c.send(message);
	  }
	  else {
		  const message = mqtt.parsePayload(
			  "aimily/req/" + userId + "/checkStatus",
			  JSON.stringify(jsonMessage)
		  );

		  c.send(message);
      }
  };
  const options = {
    print: false,
    download: false,
    filter: false,
	viewColumns: false,
	rowsPerPage: 15,
	rowsPerPageOptions: [],
    selectableRows: "none",
    textLabels: {
      body: {
        noMatch: listLoading ? (
          <CircularProgress size={25} color={"inherit"} />
        ) : botMonitoringList.length > 0 ? (
          ""
        ) : (
          "검색 결과가 없습니다."
        ),
      },
    },
  };

  const columns = [
    {
      name: "botId",
      label: "Bot ID",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "botExeRate",
      label: "실행률",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
        customBodyRender: (value, meta) => {
          const a = value.split("/");
          let exeRate = parseInt((parseInt(a[0]) / parseInt(a[1])) * 100);
          let totalExeCnt = a[1];
          let nowExeCnt = a[0];

          return (
            <div className="d-flex flex-column w-100 mr-2">
              <div className="d-flex align-items-center justify-content-between mb-2">
                <span className="text-muted mr-2 font-size-sm font-weight-bold">
                  {isNaN(exeRate) ? 0 : exeRate}%
                </span>
                <span className="text-muted font-size-sm font-weight-bold">
                  ({value})
                </span>
              </div>
              <div className="progress progress-xs w-100">
                <div
                  className="progress-bar bg-danger"
                  role="progressbar"
                  style={{ width: exeRate + "%"}}
                  aria-valuenow={nowExeCnt}
                  aria-valuemin="0"
                  aria-valuemax={totalExeCnt}
                ></div>
              </div>
            </div>
          );
        },
      },
    },
    {
      name: "botStatus",
      label: "BOT 상태",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
        customBodyRender: (value, meta) => {
			let statusCss = "btn btn-";
			let status = "";
			console.log(value);
			if (value === 0 || value == 9) {
			  statusCss = statusCss + "secondary";
			  status = "로그아웃";
          } else if (value === 1) {
			  statusCss = statusCss + "success";
			  status = "로그인";
          } else if (value === 2) {
			  statusCss = statusCss + "warning";
			  status = "실행중";
	      }
			return (
				<button class={statusCss} type="button" style={{ height: "25px", paddingTop: "2.5px", fontSize: "0.875rem" }}>{status}</button>
			);
        },
      },
    },
    {
      name: "botExeName",
      label: "실행 작업명",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
		  }),
		  customBodyRender: (value, meta) => {
			  if (value === "" || value === undefined) {
				  return "-";
			  }
			  else {
				  return value;
              }
		  },
      },
    },
    {
      name: "botExeType",
      label: "실행 타입",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
        customBodyRender: (value, meta) => {
			if (value === 1) {
				return "레시피";
			} else if (value === 2) {
				return "북";
			} else if (value === 3) {
				return "예약";
			} else {
				return "-";
            }
        },
      },
    },
    {
		name: "botExeCnt",
      label: "전체 실행건수",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "botSuccessCnt",
      label: "실행 성공건수",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "botFailCnt",
      label: "실행 실패건수",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "lastDate",
      label: "최종 실행 완료일시",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
			className: classes.centeredHeader,
			style: { width: "200px" }
        }),
      },
    },
  ];

  return (
    <div id="pageid24">
      <div
        className="d-flex align-items-center justify-content-between w-100"
        style={{ marginTop: 30 }}
      >
        <h3 className="card-label font-weight-bolder text-dark d-flex align-items-center mb-0">
          Bot 모니터링
        </h3>
        {localStorage.getItem("userRole") === "SystemAdmin" && (
          <div className="fv-plugins-icon-container mr-5">
            <select
              className="form-control form-control-lg form-control-solid"
              style={{ borderColor: "black", width: "200px" }}
              name="botAdminList"
              onChange={(e) => fetchData(e.target.value, e.target.selectedOptions[0].text)}
            >
              <option value="">선택</option>
              {botAdminList &&
                botAdminList.length > 0 &&
                botAdminList.map((data, index) => {
                  return <option value={data.no}>{data.loginId}</option>;
                })}
            </select>
          </div>
        )}
      </div>
      <div
        style={{ marginTop: 50 }}
        className="top-row gutter-b d-flex justify-content-center align-items-center"
      >
        <p className="mb-0 top-text">※ 실행률과 건수는 <b>당일 기준</b>이며, 5초 마다 리스트를 갱신 합니다.</p>
      </div>
      <div className="gutter-b">
        <div className="table-responsive">
          <div className="table-responsive">
            <MUIDataTable
              // title={"Bot 관리"}
              data={botMonitoringList}
              columns={columns}
              options={options}
            />
          </div>
          {/* <table
						className="table table-head-custom table-vertical-center bg-white"
						id="kt_advance_table_widget_1"
					>
						<thead>
							<tr className="text-left">
								<th style={{ width: "100px" }}>Bot ID</th>
								<th style={{ width: "250px" }}>실행률</th>
								<th style={{ minWidth: "100px" }}>Bot 상태</th>
								<th style={{ width: "150px" }}>실행 작업명</th>
								<th style={{ minWidth: "100px" }}>실행 타입</th>
								<th style={{ minWidth: "100px" }}>전체 실행건수</th>
								<th style={{ minWidth: "100px" }}>실행 성공건수</th>
								<th style={{ minWidth: "200px" }}>실행 실패건수</th>
								<th className="text-right" style={{ width: "200px" }}>
									최종 실행일시
								</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Logan1</td>
								<td>
									<div className="d-flex flex-column w-100 mr-2">
										<div className="d-flex align-items-center justify-content-between mb-2">
											<span className="text-muted mr-2 font-size-sm font-weight-bold">
												50%
											</span>
											<span className="text-muted font-size-sm font-weight-bold">
												(50/100)
											</span>
										</div>
										<div className="progress progress-xs w-100">
											<div
												className="progress-bar bg-danger"
												role="progressbar"
												style={{ width: "50%" }}
												aria-valuenow="50"
												aria-valuemin="0"
												aria-valuemax="100"
											></div>
										</div>
									</div>
								</td>
								<td>
									<span className="label label-xl label-inline label-warning">
										실행중
									</span>
								</td>
								<td className="text-overflow-ellipsis">
									<nobr>오전 예약 중 상품 어쩌고 저쩌고 쫑알쫑알 하하하</nobr>
								</td>
								<td>예약</td>
								<td>100</td>
								<td>50</td>
								<td>50</td>
								<td className="text-right">2021-05-13 16:50:20</td>
							</tr>
							<tr>
								<td>Logan1</td>
								<td>
									<div className="d-flex flex-column w-100 mr-2">
										<div className="d-flex align-items-center justify-content-between mb-2">
											<span className="text-muted mr-2 font-size-sm font-weight-bold">
												40%
											</span>
											<span className="text-muted font-size-sm font-weight-bold">
												(40/100)
											</span>
										</div>
										<div className="progress progress-xs w-100">
											<div
												className="progress-bar bg-danger"
												role="progressbar"
												style={{ width: "40%" }}
												aria-valuenow="50"
												aria-valuemin="0"
												aria-valuemax="100"
											></div>
										</div>
									</div>
								</td>
								<td>
									<span className="label label-xl label-inline label-success">
										로그인
									</span>
								</td>
								<td className="text-overflow-ellipsis">
									<nobr>오전 예약 중 상품 어쩌고 저쩌고 쫑알쫑알 하하하</nobr>
								</td>
								<td>예약</td>
								<td>100</td>
								<td>50</td>
								<td>50</td>
								<td className="text-right">2021-05-13 16:50:20</td>
							</tr>
							<tr>
								<td>Logan1</td>
								<td>
									<div className="d-flex flex-column w-100 mr-2">
										<div className="d-flex align-items-center justify-content-between mb-2">
											<span className="text-muted mr-2 font-size-sm font-weight-bold">
												10%
											</span>
											<span className="text-muted font-size-sm font-weight-bold">
												(10/100)
											</span>
										</div>
										<div className="progress progress-xs w-100">
											<div
												className="progress-bar bg-danger"
												role="progressbar"
												style={{ width: "10%" }}
												aria-valuenow="50"
												aria-valuemin="0"
												aria-valuemax="100"
											></div>
										</div>
									</div>
								</td>
								<td>
									<span className="label label-xl label-inline label-light-dark">
										로그아웃
									</span>
								</td>
								<td className="text-overflow-ellipsis">
									<nobr>오전 예약 중 상품 어쩌고 저쩌고 쫑알쫑알 하하하</nobr>
								</td>
								<td>예약</td>
								<td>100</td>
								<td>50</td>
								<td>50</td>
								<td className="text-right">2021-05-13 16:50:20</td>
							</tr>
							<tr>
								<td>Logan1</td>
								<td>
									<div className="d-flex flex-column w-100 mr-2">
										<div className="d-flex align-items-center justify-content-between mb-2">
											<span className="text-muted mr-2 font-size-sm font-weight-bold">
												10%
											</span>
											<span className="text-muted font-size-sm font-weight-bold">
												(10/100)
											</span>
										</div>
										<div className="progress progress-xs w-100">
											<div
												className="progress-bar bg-danger"
												role="progressbar"
												style={{ width: "10%" }}
												aria-valuenow="50"
												aria-valuemin="0"
												aria-valuemax="100"
											></div>
										</div>
									</div>
								</td>
								<td>
									<span className="label label-xl label-inline label-light-dark">
										로그아웃
									</span>
								</td>
								<td className="text-overflow-ellipsis">
									<nobr>오전 예약 중 상품 어쩌고 저쩌고 쫑알쫑알 하하하</nobr>
								</td>
								<td>예약</td>
								<td>100</td>
								<td>50</td>
								<td>50</td>
								<td className="text-right">2021-05-13 16:50:20</td>
							</tr>
							<tr>
								<td>Logan1</td>
								<td>
									<div className="d-flex flex-column w-100 mr-2">
										<div className="d-flex align-items-center justify-content-between mb-2">
											<span className="text-muted mr-2 font-size-sm font-weight-bold">
												10%
											</span>
											<span className="text-muted font-size-sm font-weight-bold">
												(10/100)
											</span>
										</div>
										<div className="progress progress-xs w-100">
											<div
												className="progress-bar bg-danger"
												role="progressbar"
												style={{ width: "10%" }}
												aria-valuenow="50"
												aria-valuemin="0"
												aria-valuemax="100"
											></div>
										</div>
									</div>
								</td>
								<td>
									<span className="label label-xl label-inline label-light-dark">
										로그아웃
									</span>
								</td>
								<td className="text-overflow-ellipsis">
									<nobr>오전 예약 중 상품 어쩌고 저쩌고 쫑알쫑알 하하하</nobr>
								</td>
								<td>예약</td>
								<td>100</td>
								<td>50</td>
								<td>50</td>
								<td className="text-right">2021-05-13 16:50:20</td>
							</tr>
							<tr>
								<td>Logan1</td>
								<td>
									<div className="d-flex flex-column w-100 mr-2">
										<div className="d-flex align-items-center justify-content-between mb-2">
											<span className="text-muted mr-2 font-size-sm font-weight-bold">
												10%
											</span>
											<span className="text-muted font-size-sm font-weight-bold">
												(10/100)
											</span>
										</div>
										<div className="progress progress-xs w-100">
											<div
												className="progress-bar bg-danger"
												role="progressbar"
												style={{ width: "10%" }}
												aria-valuenow="50"
												aria-valuemin="0"
												aria-valuemax="100"
											></div>
										</div>
									</div>
								</td>
								<td>
									<span className="label label-xl label-inline label-light-dark">
										로그아웃
									</span>
								</td>
								<td className="text-overflow-ellipsis">
									<nobr>오전 예약 중 상품 어쩌고 저쩌고 쫑알쫑알 하하하</nobr>
								</td>
								<td>예약</td>
								<td>100</td>
								<td>50</td>
								<td>50</td>
								<td className="text-right">2021-05-13 16:50:20</td>
							</tr>
							<tr>
								<td>Logan1</td>
								<td>
									<div className="d-flex flex-column w-100 mr-2">
										<div className="d-flex align-items-center justify-content-between mb-2">
											<span className="text-muted mr-2 font-size-sm font-weight-bold">
												10%
											</span>
											<span className="text-muted font-size-sm font-weight-bold">
												(10/100)
											</span>
										</div>
										<div className="progress progress-xs w-100">
											<div
												className="progress-bar bg-danger"
												role="progressbar"
												style={{ width: "10%" }}
												aria-valuenow="50"
												aria-valuemin="0"
												aria-valuemax="100"
											></div>
										</div>
									</div>
								</td>
								<td>
									<span className="label label-xl label-inline label-light-dark">
										로그아웃
									</span>
								</td>
								<td className="text-overflow-ellipsis">
									<nobr>오전 예약 중 상품 어쩌고 저쩌고 쫑알쫑알 하하하</nobr>
								</td>
								<td>예약</td>
								<td>100</td>
								<td>50</td>
								<td>50</td>
								<td className="text-right">2021-05-13 16:50:20</td>
							</tr>
							<tr>
								<td>Logan1</td>
								<td>
									<div className="d-flex flex-column w-100 mr-2">
										<div className="d-flex align-items-center justify-content-between mb-2">
											<span className="text-muted mr-2 font-size-sm font-weight-bold">
												10%
											</span>
											<span className="text-muted font-size-sm font-weight-bold">
												(10/100)
											</span>
										</div>
										<div className="progress progress-xs w-100">
											<div
												className="progress-bar bg-danger"
												role="progressbar"
												style={{ width: "10%" }}
												aria-valuenow="50"
												aria-valuemin="0"
												aria-valuemax="100"
											></div>
										</div>
									</div>
								</td>
								<td>
									<span className="label label-xl label-inline label-light-dark">
										로그아웃
									</span>
								</td>
								<td className="text-overflow-ellipsis">
									<nobr>오전 예약 중 상품 어쩌고 저쩌고 쫑알쫑알 하하하</nobr>
								</td>
								<td>예약</td>
								<td>100</td>
								<td>50</td>
								<td>50</td>
								<td className="text-right">2021-05-13 16:50:20</td>
							</tr>
							<tr>
								<td>Logan1</td>
								<td>
									<div className="d-flex flex-column w-100 mr-2">
										<div className="d-flex align-items-center justify-content-between mb-2">
											<span className="text-muted mr-2 font-size-sm font-weight-bold">
												10%
											</span>
											<span className="text-muted font-size-sm font-weight-bold">
												(10/100)
											</span>
										</div>
										<div className="progress progress-xs w-100">
											<div
												className="progress-bar bg-danger"
												role="progressbar"
												style={{ width: "10%" }}
												aria-valuenow="50"
												aria-valuemin="0"
												aria-valuemax="100"
											></div>
										</div>
									</div>
								</td>
								<td>
									<span className="label label-xl label-inline label-light-dark">
										로그아웃
									</span>
								</td>
								<td className="text-overflow-ellipsis">
									<nobr>오전 예약 중 상품 어쩌고 저쩌고 쫑알쫑알 하하하</nobr>
								</td>
								<td>예약</td>
								<td>100</td>
								<td>50</td>
								<td>50</td>
								<td className="text-right">2021-05-13 16:50:20</td>
							</tr>
							<tr>
								<td>Logan1</td>
								<td>
									<div className="d-flex flex-column w-100 mr-2">
										<div className="d-flex align-items-center justify-content-between mb-2">
											<span className="text-muted mr-2 font-size-sm font-weight-bold">
												10%
											</span>
											<span className="text-muted font-size-sm font-weight-bold">
												(10/100)
											</span>
										</div>
										<div className="progress progress-xs w-100">
											<div
												className="progress-bar bg-danger"
												role="progressbar"
												style={{ width: "10%" }}
												aria-valuenow="50"
												aria-valuemin="0"
												aria-valuemax="100"
											></div>
										</div>
									</div>
								</td>
								<td>
									<span className="label label-xl label-inline label-light-dark">
										로그아웃
									</span>
								</td>
								<td className="text-overflow-ellipsis">
									<nobr>오전 예약 중 상품 어쩌고 저쩌고 쫑알쫑알 하하하</nobr>
								</td>
								<td>예약</td>
								<td>100</td>
								<td>50</td>
								<td>50</td>
								<td className="text-right">2021-05-13 16:50:20</td>
							</tr>
						</tbody>
					</table> */}
        </div>
        {/* end::Table */}
      </div>
      {/* <div className="row">
				<div className="d-flex flex-center w-100">
					<Pagination>
						<Pagination.Prev />

						<Pagination.Item>{1}</Pagination.Item>
						<Pagination.Item>{2}</Pagination.Item>
						<Pagination.Item active>{3}</Pagination.Item>
						<Pagination.Item disabled>{4}</Pagination.Item>
						<Pagination.Item>{5}</Pagination.Item>

						<Pagination.Next />
					</Pagination>
				</div>
			</div> */}
    </div>
  );
}
export default BotMonitoring;
